<app-spinner></app-spinner>
<app-snackbar></app-snackbar>
<!-- <app-modal-pdf-viewer></app-modal-pdf-viewer> -->
<!-- <app-modal-image-viewer></app-modal-image-viewer> -->
<!-- <app-welcome-user *ngIf="showWelcomeMessage"></app-welcome-user> -->
<!-- <app-contact-us *ngIf="showContactUs"></app-contact-us> -->
<!-- <app-header [moduleDetails]="moduleDetails" [menuItems]="menuItems"></app-header> -->
<app-header [moduleDetails]="moduleDetails" [menuItems]="menuItems" onLoad="reload()"></app-header>
<router-outlet></router-outlet>
